import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import userAPI from '../../sources/api/userAPI';

// constants
import { CURRENT_USER_FETCH } from '../../constants/currentUserTypes';

// lib
import httpSaga from '../../lib/httpSaga';
import repAPI from '../../sources/api/repAPI';
import managerAPI from '../../sources/api/managerAPI';

function updateUser(type, params) {
  if (type === 'rep') {
    repAPI.updateSelf(params);
  } else if (type === 'manager') {
    managerAPI.updateSelf(params);
  }
}

function* initFreshChat({ user, restoreId }) {
  const splittedName = user.name.split(' ');
  const notEmptyNames = splittedName.filter((element) => element !== '');
  const firstName = notEmptyNames[0] || '';
  const lastName = notEmptyNames[notEmptyNames.length - 1] || '';

  yield window.fcWidget.init({
    token: process.env.FRESH_CHAT_TOKEN,
    host: process.env.FRESH_CHAT_HOST,
    externalId: user.id,     // user’s id unique to your system
    firstName: firstName,              // user’s first name
    lastName: lastName,                // user’s last name
    email: user.email,                // user’s last name
    restoreId: restoreId ? restoreId : null,
    tags: [user.type == 'manager' ? 'office' : 'rep']
    // Commenting it for client's verification
    // faqTags: {
    //   tags: [user.type == 'manager' ? 'office_faqs' : 'rep_faqs'],
    //   filterType: 'article'
    // }
  });
  yield window.fcWidget.user.get(function(resp) {
    const status = resp && resp.status;

    if (status !== 200) {
      window.fcWidget.user.setProperties({
        firstName: firstName,              // user’s first name
        lastName: lastName,                // user’s last name
        email: user.email,              // user’s last name
        status: 'Active'               // user's meta property 2
      });
      window.fcWidget.on('user:created', function(createResp) {
        const createdStatus = createResp && createResp.status,
              createdData = createResp && createResp.data;

        if (createdStatus === 200) {
          if (createdData.restoreId) {
            const params = {
              freshchatId: createdData.restoreId
            };

            updateUser(user.type, params);
          }
        }
      });
    }
  });
}

export function* currentUserFetch(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  try {
    const response = yield *httpSaga(CURRENT_USER_FETCH, call(userAPI.fetchSelf));
    const user      = response.body;
    const restoreId = user.freshchatId;

    yield call(initFreshChat, { user, restoreId });
  } catch (err) {
    yield put(error(CURRENT_USER_FETCH, err));
  } finally {
    yield put(doneIndicator(CURRENT_USER_FETCH));
  }
}

export function* watchCurrentUserFetch() {
  yield takeEvery(CURRENT_USER_FETCH, currentUserFetch);
}

export default function* root() {
  yield all([
    fork(watchCurrentUserFetch)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/user/currentUserFetch.js